import styled from 'styled-components';

export const SettingsSliderContainer = styled.div`
  
  position: relative;
  max-width: 100%;
  height: 100%;

  

  &.is-open {
    overflow: hidden;

    .content,
    .settings {    
      animation: toggleDisplay .5s ease forwards;
    }

    .settings { 
      width: 300px;
    }
  }
  
  .settings { 
    display: grid;
    grid-template-rows: auto 1fr;
    position: absolute;
    width: 0;
    height: 100%;
    overflow: hidden;
    background: red;
    left: 100%;
    top: 0;

    .scroll-area {
      overflow-y: auto;
      height: 100%;
    }
  }

  @keyframes toggleDisplay {
    0% {
      overflow: visible;
    }
    1% {
      overflow: hidden;
      transform: translateX(0);
    }
    100% {
      overflow: hidden;
      transform: translateX(-300px);
    }
  }
  
`


/*
&.is-open {

    overflow: hidden;

    .content,
    .settings {    
      animation: toggleDisplay .5s ease forwards;
    }

    .settings { 
      overflow: visible;
      width: 300px;
      background: red;
      left: 100%;
    }
  }


  .settings {
    position: absolute;
    width: 0:
    height: 100%;
    overflow: hidden;
  }
    */